import classnames from 'classnames'

import type { PortableTextComponentProps } from '~/components/atoms/BlockContent/BlockContent'
import BlockContent from '~/components/atoms/BlockContent/BlockContent'
import Fixture from '~/components/atoms/Fixture/Fixture'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { ComponentTheme } from '~/components/themes'

import styles from './NumberBlock.module.css'

export interface NumberBlockProps {
  _key: string
  number: number
  title: string
  body: PortableTextComponentProps['blocks']
  theme?: ComponentTheme
  verticalPadding?: boolean
  noPaddingBottom?: boolean
  testID?: string
  variant: null | 'magazine'
}

export default function NumberBlock({
  _key,
  number,
  title,
  body,
  theme = ComponentTheme.primary,
  verticalPadding,
  noPaddingBottom,
  testID,
  variant,
}: NumberBlockProps) {
  return (
    <Fixture
      theme={theme}
      verticalPadding={verticalPadding}
      noPaddingBottom={noPaddingBottom}
    >
      <div
        className={classnames(styles.base, variant && styles[variant])}
        data-testid={testID}
        id={_key}
      >
        <Text className={styles.number} size={TextSizes.magPrimaryTitleLrg}>
          {number}.
        </Text>
        <Text
          className={styles.title}
          size={TextSizes.magPrimaryTitleSml}
          Tag="h2"
        >
          {title}
        </Text>
        <div className={classnames(styles.bodyText, 'prose')}>
          <BlockContent value={body} size={TextSizes.bodyLrg} />
        </div>
      </div>
    </Fixture>
  )
}
